import { render, staticRenderFns } from "./location-card.vue?vue&type=template&id=b7cbfcd2&scoped=true&"
import script from "./location-card.vue?vue&type=script&lang=js&"
export * from "./location-card.vue?vue&type=script&lang=js&"
import style0 from "./location-card.vue?vue&type=style&index=0&id=b7cbfcd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cbfcd2",
  null
  
)

export default component.exports